// extracted by mini-css-extract-plugin
export default {"root":"HeaderLogo_root__sxKHh","logoWrapper":"HeaderLogo_logoWrapper__K9Rn2","logoIcon":"HeaderLogo_logoIcon__HYtqL","logoTextIcon":"HeaderLogo_logoTextIcon__RpLb6"};